<template>
  <v-dialog v-model="isOpen" :persistent="true" max-width="500">
    <v-card class="base-confirm bg-white rounded-lg">
      <v-card-title class="bb-base-dialog__header">
        <slot name="header">
          {{ state.title }}
        </slot>
        <slot name="close">
          <v-icon small class="cursor-pointer" @click="noAction.handler">
            mdi-close
          </v-icon>
        </slot>
        <v-spacer />
      </v-card-title>
      <v-card-text class="bb-base-confirm__content">
        <template v-if="state.loading">
          <slot name="spinner">
            <div class="p-10 text-center"></div>
          </slot>
        </template>
        <template v-else>
          <div v-if="state.text" class="bb-base-confirm-text">
            {{ state.text }}
          </div>
          <div v-if="state.subtitle" class="bb-base-confirm-subtitle">
            {{ state.subtitle }}
          </div>
        </template>
      </v-card-text>
      <v-card-actions
        v-if="!state.loading && state.actions"
        class="bb-base-dialog__footer"
      >
        <slot
          name="footer"
          :loading="state.loading"
          :actions="state.actions"
          :yes="state.yes"
          :no="state.no"
          :yesAction="yesAction"
          :noAction="noAction"
        >
          <v-spacer />
          <v-btn
            v-if="state.no"
            primary
            type="submit"
            color="primary"
            variant="flat"
            @click="noAction.handler"
            outline
          >
            {{ noAction.text }}
          </v-btn>
          <v-btn
            v-if="state.yes"
            primary
            type="submit"
            color="primary"
            variant="flat"
            @click="yesAction.handler"
          >
            {{ yesAction.text }}
          </v-btn>
        </slot>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script setup>
import { computed } from "vue";
import { actions, state } from "@/composables/useConfirm";

const noAction = computed(() => actions.value[0]);
const yesAction = computed(() => actions.value[1]);

const isOpen = computed({
  get: () => state.open || state.loading,
  set: (val) => {
    if (val) yesAction.value.handler();
    else noAction.value.handler();
  },
});
</script>

<style lang="postcss">
.base-confirm {
  @apply focus:outline-none;
}

.bb-base-dialog__header {
  @apply items-center px-10 border-b border-grey-300 min-h-[87px] text-2xl font-poppins text-primary-800;
}

.bb-base-confirm__content {
  @apply flex flex-col gap-y-5 px-10 pb-7;
}

.bb-base-confirm-text {
  @apply font-poppins text-sm text-grey-800;
}

.bb-base-confirm-subtitle {
  @apply font-poppins text-xl;
}

.bb-base-dialog__footer {
  @apply flex justify-end gap-x-3 px-10 py-4 border-t border-grey-300;
}
</style>
